import {
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from '@material-ui/core';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendAdminRequest } from '../../api/websocketApi';
import useStore from '../../store/store';

interface Country {
    Iso2: string;
    Name: string;
    PhoneCode: number;
}

interface APIResponse {
    success: boolean;
    errCode?:
        | 'invalid_param'
        | 'invalid_token'
        | 'auth_failed'
        | 'access_denied'
        | 'phone_not_found'
        | 'email_not_found';
    errDetails?: string;
    userId?: number;
    institution?: string;
    phone?: string;
    email?: string;
}

const SearchUsersForm = () => {
    const [iso2, setIso2] = useState(localStorage.getItem('iso2') || '');
    const countries = useStore((state) => state.countries);
    const setFormError = useStore((state) => state.setFormError);
    const { setUserId, setUserInstitution, setUserPhone, setUserEmail } =
        useStore((state) => state);
    const navigate = useNavigate();

    const handleSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();
        const target = e.target as typeof e.target & {
            phone: { value: string };
            email: { value: string };
        };
        const phone = target.phone.value;
        const email = target.email.value;

        sendAdminRequest(
            {
                endpoint: '/user/get-by-phone-or-email',
                body: {
                    ...(phone && iso2 && { iso2, phone }),
                    ...(email && { email }),
                },
            },
            (data: APIResponse) => {
                if (data.success && typeof data.userId === 'number') {
                    setUserId(data.userId);
                    setUserInstitution(data.institution);
                    setUserPhone(data.phone);
                    setUserEmail(data.email);
                    navigate(`/admin/user/${data.userId}`);
                } else if (!data.success && data.errCode) {
                    setFormError('');
                    setTimeout(() => setFormError(data.errCode), 0);
                    console.error(data.errCode);
                    if (data.errDetails) console.error(data.errDetails);
                }
            }
        );
    };

    return (
        <form
            onSubmit={handleSubmit}
            style={{ display: 'flex', gap: '10px', marginBottom: '-30px' }}
        >
            <FormControl fullWidth>
                <InputLabel id="sex-select-label">Country</InputLabel>
                <Select
                    labelId="country-select-label"
                    id="country-select"
                    name="country"
                    label="Country"
                    onChange={(e) => setIso2(e.target.value as string)}
                    displayEmpty
                    value={iso2}
                >
                    {countries.map((country: Country) => (
                        <MenuItem key={country.Iso2} value={country.Iso2}>
                            {country.Name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <TextField
                autoFocus
                margin="dense"
                id="phone"
                name="phone"
                label="Phone"
                type="tel"
                fullWidth
                variant="outlined"
                autoComplete="tel-national"
                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                onChange={(event) => {
                    const numericValue = event.target.value.replace(
                        /[^\d]/g,
                        ''
                    );
                    event.target.value = numericValue;
                }}
            />

            <TextField
                margin="dense"
                id="email"
                name="email"
                label="E-mail"
                type="email"
                fullWidth
                variant="outlined"
                autoComplete="email"
            />

            <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                style={{
                    borderRadius: '25px',
                    margin: '10px',
                    width: '400px',
                    boxShadow: 'none',
                    textTransform: 'none',
                    fontWeight: 'bold',
                }}
            >
                Search User
            </Button>
        </form>
    );
};

export default SearchUsersForm;
